import ImagesBrandsPopularArdbegWebp from '@/public/images/brands/popular/Ardbeg.webp';
import ImagesBrandsPopularBowmorePng from '@/public/images/brands/popular/Bowmore.png';
import ImagesBrandsPopularChichibuPng from '@/public/images/brands/popular/Chichibu.png';
import ImagesBrandsPopularGlenfiddichPng from '@/public/images/brands/popular/Glenfiddich.png';
import ImagesBrandsPopularGlenmorangiePng from '@/public/images/brands/popular/Glenmorangie.png';
import ImagesBrandsPopularHennessyWebp from '@/public/images/brands/popular/Hennessy.webp';
import ImagesBrandsPopularJohnnieWalkerPng from '@/public/images/brands/popular/Johnnie-Walker.png';
import ImagesBrandsPopularLagavulinPng from '@/public/images/brands/popular/Lagavulin.png';
import ImagesBrandsPopularLaphroaigSingleIslayMaltScotchWhiskyLogoPng from '@/public/images/brands/popular/laphroaig-single-islay-malt-scotch-whisky-logo.png';
import ImagesBrandsPopularMacallanPng from '@/public/images/brands/popular/Macallan.png';
import ImagesBrandsPopularObanWebp from '@/public/images/brands/popular/Oban.webp';
import ImagesBrandsPopularTaliskerPng from '@/public/images/brands/popular/Talisker.png';
import ImagesBrandsPopularTheGlenlivetPng from '@/public/images/brands/popular/The-Glenlivet.png';
import ImagesBrandsPopularYamazakiPng from '@/public/images/brands/popular/yamazaki.png';

export {
  ImagesBrandsPopularArdbegWebp,
  ImagesBrandsPopularBowmorePng,
  ImagesBrandsPopularChichibuPng,
  ImagesBrandsPopularGlenfiddichPng,
  ImagesBrandsPopularGlenmorangiePng,
  ImagesBrandsPopularHennessyWebp,
  ImagesBrandsPopularJohnnieWalkerPng,
  ImagesBrandsPopularLagavulinPng,
  ImagesBrandsPopularLaphroaigSingleIslayMaltScotchWhiskyLogoPng,
  ImagesBrandsPopularMacallanPng,
  ImagesBrandsPopularObanWebp,
  ImagesBrandsPopularTaliskerPng,
  ImagesBrandsPopularTheGlenlivetPng,
  ImagesBrandsPopularYamazakiPng,
};
